// Instance Builder Module - Frontend Entry Point

export const instanceBuilderRoutes = [
  {
    path: "instance-builder",
    name: "InstanceBuilder",
    component: () => import("./components/InstanceBuilder.vue"),
    meta: { 
      title: "Instance Builder", 
      requiresAuth: true, 
      requiresModule: "instance_builder_module" 
    },
  },
];

export default {
  routes: instanceBuilderRoutes,
};

